import { FolderIcon, MoreHorizontalIcon, ShareIcon, type LucideIcon } from "lucide-react";

import { DropdownMenu } from "@/components/ui/dropdown-menu";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { Link } from "react-router-dom";

export default function SidebarElement({
  items,
  elementLabel,
}: {
  items: {
    name: string;
    url: string;
    icon: LucideIcon;
  }[];
  elementLabel: string;
}) {
  return (
    <SidebarGroup className="group-data-[collapsible=icon]:hidden pl-0 pt-10">
      <SidebarGroupLabel className="text-[#424242B3]">{elementLabel ?? "Default Label"}</SidebarGroupLabel>
      <SidebarMenu>
        {items?.map((item) => (
          <SidebarMenuItem key={item?.name}>
            <SidebarMenuButton asChild>
              <Link to={item?.url} className="text-[#1A1A1A] hover:bg-gray-200">
                <item.icon className="text-[#1A1A1A]" />
                <span>{item?.name}</span>
              </Link>
            </SidebarMenuButton>
            <DropdownMenu></DropdownMenu>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
